(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6809],{

/***/ 21728:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/detailPackage",
      function () {
        return __webpack_require__(75979);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _QUERIES_prdt_event_useEventPrice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8745);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var TaggingGTM = function(props) {
    var ref;
    // 아래는 Google tag manager 관련
    var eventPriceFetch = (0,_QUERIES_prdt_event_useEventPrice__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(props.query.evCd);
    var eventPrice = (ref = eventPriceFetch.data) === null || ref === void 0 ? void 0 : ref.body;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!eventPrice) return;
        try {
            dataLayer.push({
                event: "addToCart",
                ecommerce: {
                    currencyCode: "KRW",
                    add: {
                        products: [
                            {
                                name: "".concat(props.eventDetail.evNm),
                                id: "".concat(props.goodsDetail.goodsCd),
                                price: "".concat(Number(eventPrice.adtPrice + eventPrice.bafAdtCost + eventPrice.airTaxAdtCost)),
                                category: "".concat(props.query.menu)
                            }, 
                        ]
                    }
                }
            });
        } catch (e) {
            ;
        }
    }, [
        eventPrice
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (TaggingGTM);


/***/ }),

/***/ 26195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ CountingWrap; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _FRAMEWORK_ui_desktop_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9873);
/* harmony import */ var _FRAMEWORK_ui_desktop_input__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58127);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93391);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	button {\n		width: 35px;\n		height: 38px;\n\n		&:before {\n			top: 50%;\n			left: 50%;\n			transform: translate(-50%, -50%);\n		}\n\n		&:after {\n			top: 50%;\n			left: 50%;\n			transform: translate(-50%, -50%);\n		}\n	}\n	input {\n		height: 38px;\n		padding: 10px 5px;\n		font-size: 15px;\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var CountingWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-781112e0-0"
})(_templateObject());
var CountingButton = function(param) {
    var increase = param.increase, decrease = param.decrease, onClick = param.onClick, value = param.value, _minValue = param.minValue, minValue = _minValue === void 0 ? 0 : _minValue;
    var maxValue = 30;
    var onIncrease = function() {
        var increaseNumber = value + 1;
        typeof increase === "function" && increase(increaseNumber);
        typeof onClick === "function" && onClick("plus", increaseNumber);
    };
    var onDecrease = function() {
        var decreasedNumber = Math.max(value - 1, 0);
        typeof decrease === "function" && decrease(decreasedNumber);
        typeof onClick === "function" && onClick("minus", decreasedNumber);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CountingWrap, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_FRAMEWORK_ui_desktop_button__WEBPACK_IMPORTED_MODULE_2__/* .NumberButton */ ._7, {
                types: "minus",
                onClick: onDecrease,
                disabled: value <= minValue
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_FRAMEWORK_ui_desktop_input__WEBPACK_IMPORTED_MODULE_3__/* .NumberInput */ .Y2, {
                width: "38px",
                value: value,
                readOnly: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_FRAMEWORK_ui_desktop_button__WEBPACK_IMPORTED_MODULE_2__/* .NumberButton */ ._7, {
                types: "plus",
                onClick: onIncrease,
                disabled: value >= maxValue
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CountingButton);



/***/ }),

/***/ 13028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21741);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




var key = "useEventPromotion";
/** ```
 * 행사 관련기획전 리스트 조회
 *   `/event/{evCd}/promotion`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var getPath = function(evCd) {
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PRODUCT_API_BASEPATH */ .Z.ENV_PRODUCT_API_BASEPATH, "/api/event/").concat(evCd, "/promotion");
};
/** ```
 * 행사 관련기획전 리스트 조회
 *   `/event/{evCd}/promotion`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var useEventPromotion = function(evCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(evCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(evCd)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useEventPromotion);



/***/ }),

/***/ 37192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key, goodsRecommendAsync */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21741);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




var key = "useGoodsRecommend";
/** ```
 * 상품 추천 상품 조회
 *   `/goods/{goodsCd}/recommend/{dspSid}`
 *   `/goods/{goodsCd}/recommend/{dspSid}/{webCustNo}`
 * parameter
 *   `goodsCd` 상품코드
 *   `dspSid` 메뉴코드
 *   `webCustNo?` 유저식별코드
 * ```*/ var getPath = function(goodsCd, dspSid, webCustNo) {
    if (!webCustNo) return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PRODUCT_API_BASEPATH */ .Z.ENV_PRODUCT_API_BASEPATH, "/api/goods/").concat(goodsCd, "/recommend/").concat(dspSid);
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PRODUCT_API_BASEPATH */ .Z.ENV_PRODUCT_API_BASEPATH, "/api/goods/").concat(goodsCd, "/recommend/").concat(dspSid, "/").concat(webCustNo);
};
/** ```
 * 상품 추천 상품 조회
 *   `/goods/{goodsCd}/recommend/{dspSid}`
 *   `/goods/{goodsCd}/recommend/{dspSid}/{webCustNo}`
 * parameter
 *   `goodsCd` 상품코드
 *   `dspSid` 메뉴코드
 *   `webCustNo?` 유저식별코드
 * ```*/ var goodsRecommendAsync = function(goodsCd, dspSid) {
    var webCustNo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    return useConfigureAxios(publicRuntimeConfig.ENV_PRODUCT_API_URL + getPath(goodsCd, dspSid, webCustNo), {
        method: "GET"
    });
};
/** ```
 * 상품 추천 상품 조회
 *   `/goods/{goodsCd}/recommend/{dspSid}`
 *   `/goods/{goodsCd}/recommend/{dspSid}/{webCustNo}`
 * parameter
 *   `goodsCd` 상품코드
 *   `dspSid` 메뉴코드
 *   `webCustNo?` 유저식별코드
 * ```*/ var useGoodsRecommend = function(goodsCd, dspSid) {
    var webCustNo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", options = arguments.length > 3 ? arguments[3] : void 0;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(goodsCd, dspSid, webCustNo)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(goodsCd, dspSid, webCustNo)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useGoodsRecommend);



/***/ }),

/***/ 75979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ detailPackage_page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./hooks/common/useTagging.ts + 5 modules
var useTagging = __webpack_require__(40070);
// EXTERNAL MODULE: ./components/common/commonUtil.ts
var commonUtil = __webpack_require__(2576);
// EXTERNAL MODULE: ./components/common/error/ErrorBoundary.tsx + 8 modules
var ErrorBoundary = __webpack_require__(17550);
// EXTERNAL MODULE: ./components/common/goodsUtil.ts
var goodsUtil = __webpack_require__(68284);
// EXTERNAL MODULE: ./components/layout/breadcrumbs/desktop/index.tsx + 1 modules
var desktop = __webpack_require__(96646);
// EXTERNAL MODULE: ./components/layout/footer/Desktop/index.tsx + 1 modules
var Desktop = __webpack_require__(19145);
// EXTERNAL MODULE: ./components/layout/header/Desktop/index.tsx + 8 modules
var header_Desktop = __webpack_require__(2370);
// EXTERNAL MODULE: ./components/product/pages/detailPackage/common/GTMTags.tsx
var GTMTags = __webpack_require__(9946);
// EXTERNAL MODULE: ./components/product/pages/detailPackage/desktop/DetailContents.tsx + 1 modules
var DetailContents = __webpack_require__(36017);
// EXTERNAL MODULE: ./components/product/pages/detailPackage/desktop/DetailHeader.tsx + 1 modules
var DetailHeader = __webpack_require__(29624);
// EXTERNAL MODULE: ./framework/ui/desktop/text/index.ts + 2 modules
var desktop_text = __webpack_require__(81499);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
;// CONCATENATED MODULE: ./components/style/detailpackage/promotionlink.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 910px;\n	margin: 60px auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	width: 100%;\n	margin-top: 20px;\n	border: 1px solid var(--yellow-color);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: var(--default-size);\n	+ li {\n		border-top: 1px solid var(--yellow-color);\n	}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	justify-content: space-between;\n	padding: 16px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	align-items: center;\n	white-space: nowrap;\n	margin-left: 10px;\n	border-bottom: 1px solid var(--default-color);\n	&::after {\n		display: inline-block;\n		width: 7px;\n		height: 7px;\n		margin-top: 2px;\n		margin-left: 5px;\n		border-top: 1px solid var(--default-color);\n		border-left: 1px solid var(--default-color);\n		transform: rotate(135deg);\n		content: "";\n	}\n'
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var Wrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3727a3f2-0"
})(_templateObject());
var LinkList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-3727a3f2-1"
})(_templateObject1());
var LinkListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-3727a3f2-2"
})(_templateObject2());
var Link = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-3727a3f2-3"
})(_templateObject3());
var LinkTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-3727a3f2-4"
})(_templateObject4(), (0,desktop_text/* Ellipsis */.mH)(1));
var LinkArrow = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-3727a3f2-5"
})(_templateObject5());


// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventPromotion.ts
var useEventPromotion = __webpack_require__(13028);
// EXTERNAL MODULE: ./framework/config/public.ts
var config_public = __webpack_require__(32423);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/product/pages/detailPackage/desktop/DetailPromotion.tsx









var DetailPromotionComponent = function(param) {
    var evCd = param.evCd;
    var ref;
    var useEvtPromotion = (0,useEventPromotion/* default */.ZP)(evCd);
    var promotionList = ((ref = useEvtPromotion.data) === null || ref === void 0 ? void 0 : ref.body) || [];
    var taggingClick = (0,useTagging/* useTaggingClick */.b)("pkg_select_promo_dtl", {
        selectDiv: "relatedBanner"
    }).taggingClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: promotionList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrap, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* SubTitle */.DK, {
                    children: "관련 기획전"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkList, {
                    children: promotionList.map(function(param, index) {
                        var mstLink = param.mstLink, mstNm = param.mstNm;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkListItem, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link, {
                                href: "#",
                                onClick: function(e) {
                                    e.preventDefault();
                                    taggingClick({
                                        link: mstLink,
                                        title: mstNm
                                    });
                                    location.href = "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL).concat(mstLink);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTitle, {
                                        dangerouslySetInnerHTML: {
                                            __html: mstNm.replaceAll(/<br\s*\/?>/gi, "")
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkArrow, {
                                        children: "기획전 바로가기"
                                    })
                                ]
                            })
                        }, index);
                    })
                })
            ]
        })
    });
};
/** 관련 기획전*/ var DetailPromotion = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailPromotion Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailPromotionComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var desktop_DetailPromotion = (/*#__PURE__*/(0,react.memo)(DetailPromotion));

// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./framework/ui/desktop/flag/index.ts
var flag = __webpack_require__(34869);
// EXTERNAL MODULE: ./public/P/images/ico/ico_nodata.png
var ico_nodata = __webpack_require__(39044);
var ico_nodata_default = /*#__PURE__*/__webpack_require__.n(ico_nodata);
;// CONCATENATED MODULE: ./components/style/detailpackage/promotionproduct.tsx

function promotionproduct_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 1200px;\n	margin: 60px auto;\n"
    ]);
    promotionproduct_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function promotionproduct_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	width: 100%;\n	padding-top: 20px;\n	margin-top: 20px;\n	border-top: 1px solid var(--line-color);\n"
    ]);
    promotionproduct_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function promotionproduct_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 1200px;\n	cursor: pointer;\n"
    ]);
    promotionproduct_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function promotionproduct_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: center;\n	width: 285px;\n	height: 195px;\n	/* background: #f7f7f7 url(",
        ") center / 100% no-repeat; */\n	> img:not(.fallback_thumb) {\n		width: 100%;\n		height: 100%;\n		object-fit: cover;\n	}\n"
    ]);
    promotionproduct_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function promotionproduct_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	padding: 15px;\n	background: #fff;\n	color: var(--default-color);\n"
    ]);
    promotionproduct_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function promotionproduct_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	height: 48px;\n	margin-bottom: 8px;\n	font-family: "pr-font-medium";\n	font-size: 16px;\n	line-height: 24px;\n	color: var(--emp-color);\n	',
        ";\n"
    ]);
    promotionproduct_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: var(--default-size);\n	color: var(--default-color);\n\n	> em {\n		margin-right: 10px;\n		color: var(--emp-color);\n	}\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: flex-end;\n	justify-content: space-between;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	margin-top: 10px;\n	margin-left: auto;\n	font-size: var(--basic-size);\n	color: var(--red-color);\n	line-height: 1;\n	text-align: right;\n\n	strong {\n		margin-right: 3px;\n		font-size: 20px;\n		font-family: "pr-font-medium";\n		font-weight: normal;\n	}\n'
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 55px;\n	height: 55px;\n	padding: 0;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	button {\n		position: absolute;\n		top: 50%;\n		width: 40px;\n		height: 40px;\n		border: 1px solid #d0d0d0;\n		border-radius: 50%;\n		background-color: #fff;\n		transform: translateY(-50%);\n\n		&:after {\n			position: absolute;\n			top: 16px;\n			display: block;\n			width: 6px;\n			height: 6px;\n			border-top: 1px solid #848484;\n			border-right: 1px solid #848484;\n			font-size: 0;\n			content: "";\n		}\n		&:hover:not(:disabled) {\n			background-color: #333;\n			border-color: #333;\n			&:after {\n				border-top: 1px solid #fff;\n				border-right: 1px solid #fff;\n			}\n		}\n		&:disabled {\n			border: 1px solid #e5e5e5;\n			cursor: unset;\n			&::after {\n				border-top: 2px solid #e5e5e5;\n				border-right: 2px solid #e5e5e5;\n			}\n		}\n	}\n'
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	right: -60px;\n\n	&:after {\n		right: 17px;\n		transform: rotate(45deg);\n	}\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	left: -60px;\n	&:after {\n		left: 17px;\n		transform: rotate(-135deg);\n	}\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}





var promotionproduct_Wrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66c28e61-0"
})(promotionproduct_templateObject());
var SlideWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66c28e61-1"
})(promotionproduct_templateObject1());
var Slider = (0,styled_components_browser_esm/* default */.ZP)(swiper_react/* Swiper */.tq).withConfig({
    componentId: "sc-66c28e61-2"
})(promotionproduct_templateObject2());
var SlideImg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66c28e61-3"
})(promotionproduct_templateObject3(), (ico_nodata_default()));
var InfoBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66c28e61-4"
})(promotionproduct_templateObject4());
var SlideTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66c28e61-5"
})(promotionproduct_templateObject5(), (0,desktop_text/* Ellipsis */.mH)(2));
var promotionproduct_Date = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66c28e61-6"
})(_templateObject6());
var InfoBottomBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66c28e61-7"
})(_templateObject7());
var Price = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66c28e61-8"
})(_templateObject8());
var Tag = (0,styled_components_browser_esm/* default */.ZP)(flag/* TagSquare */.IO).withConfig({
    componentId: "sc-66c28e61-9"
})(_templateObject9());
var SlideButtonWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66c28e61-10"
})(_templateObject10());
var SlideNextbutton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-66c28e61-11"
})(_templateObject11());
var SlidePrevbutton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-66c28e61-12"
})(_templateObject12());


// EXTERNAL MODULE: ./framework/ui/desktop/slide/index.ts + 6 modules
var slide = __webpack_require__(93774);
// EXTERNAL MODULE: ./hooks/services/queries/account/useSigninUser.ts
var useSigninUser = __webpack_require__(5142);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/goods/useGoodsRecommend.ts
var useGoodsRecommend = __webpack_require__(37192);
// EXTERNAL MODULE: ./node_modules/@yb/utils/dist/ybutil.cjs.js
var ybutil_cjs = __webpack_require__(20279);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/@yb/ui/desktop/common/Noimage/index.cjs
var Noimage = __webpack_require__(78860);
;// CONCATENATED MODULE: ./components/product/pages/detailPackage/desktop/DetailRecommend.tsx















var DetailRecommendComponent = function(query) {
    var ref, ref1;
    var evCd = query.evCd, dspSid = query.dspSid;
    var goodsCd = evCd.split("-")[0];
    /** 로그인 정보 */ var useSign = (0,useSigninUser/* default */.ZP)();
    var webCustNo = ((ref = useSign.data) === null || ref === void 0 ? void 0 : ref.body.webCustNo) || "";
    /** 추천상품 조회 */ var useGoodsRecomm = (0,useGoodsRecommend/* default */.ZP)(goodsCd, dspSid, webCustNo, {
        enabled: !useSign.isFetching
    });
    var recommendList = ((ref1 = useGoodsRecomm.data) === null || ref1 === void 0 ? void 0 : ref1.body) || [];
    var swiperRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: recommendList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(promotionproduct_Wrap, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* SubTitle */.DK, {
                    children: "추천 상품"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(slide/* RecommendationSlide */.OQ, {
                    perView: 4,
                    spaceBetween: 20,
                    ref: swiperRef,
                    children: recommendList.map(function(recommend, index) {
                        var dateStart = recommend.dateStart, dateEnd = recommend.dateEnd, goodsNm = recommend.goodsNm, minPrice = recommend.minPrice, weblinkurl = recommend.weblinkurl, imageThum3 = recommend.imageThum3;
                        var start = dayjs_min_default()(dateStart).format("YYYY.MM.DD");
                        var end = dayjs_min_default()(dateEnd).format("YYYY.MM.DD");
                        var price = ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(minPrice);
                        var link = weblinkurl.replace("detailPackage.yb", "detailPackage");
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: "#",
                                target: "_blank",
                                onClick: function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            e.preventDefault();
                                            location.href = link;
                                            return [
                                                2
                                            ];
                                        });
                                    });
                                    return function(e) {
                                        return _ref.apply(this, arguments);
                                    };
                                }(),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideImg, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Noimage/* Noimage */.T, {
                                            src: imageThum3 || "",
                                            alt: "상품 이미지",
                                            width: "285px",
                                            height: "195px"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoBox, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideTitle, {
                                                children: goodsNm
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(promotionproduct_Date, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                        children: "출발기간"
                                                    }),
                                                    start,
                                                    " ~ ",
                                                    end
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBottomBlock, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Price, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: price
                                                        }),
                                                        "원~"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, index);
                    })
                })
            ]
        })
    });
};
var DetailRecommend = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailRecommend Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailRecommendComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var desktop_DetailRecommend = (DetailRecommend);

// EXTERNAL MODULE: ./components/product/pages/detailPackage/desktop/DetailSchedule.tsx + 7 modules
var DetailSchedule = __webpack_require__(2045);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./hooks/common/useOverlay.tsx + 1 modules
var useOverlay = __webpack_require__(91864);
// EXTERNAL MODULE: ./components/common/eventUtil.ts
var eventUtil = __webpack_require__(99346);
// EXTERNAL MODULE: ./components/common/modal/alert/Desktop.tsx
var alert_Desktop = __webpack_require__(64024);
// EXTERNAL MODULE: ./components/product/common/popup/desktop/CouponPopup.tsx
var CouponPopup = __webpack_require__(98670);
// EXTERNAL MODULE: ./components/product/common/popup/desktop/EventListPopup/EventListPopup.tsx + 4 modules
var EventListPopup = __webpack_require__(89071);
// EXTERNAL MODULE: ./components/product/common/popup/desktop/PointSavePop.tsx + 1 modules
var PointSavePop = __webpack_require__(92543);
// EXTERNAL MODULE: ./components/style/detailpackage/snb.tsx
var snb = __webpack_require__(22476);
// EXTERNAL MODULE: ./framework/ui/desktop/button/index.ts + 7 modules
var desktop_button = __webpack_require__(9873);
// EXTERNAL MODULE: ./framework/ui/desktop/button/CountingButton.tsx
var CountingButton = __webpack_require__(26195);
// EXTERNAL MODULE: ./framework/ui/desktop/icon/AirlineIcon.tsx
var AirlineIcon = __webpack_require__(38502);
// EXTERNAL MODULE: ./framework/ui/desktop/layout/index.tsx + 2 modules
var layout = __webpack_require__(31267);
// EXTERNAL MODULE: ./hooks/services/queries/essential/banner/useBannerContents.ts
var useBannerContents = __webpack_require__(72204);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventMileage.ts
var useEventMileage = __webpack_require__(98846);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventPrice.ts
var useEventPrice = __webpack_require__(8745);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/goods/useGoodsOneAvailEvent.ts
var useGoodsOneAvailEvent = __webpack_require__(51820);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/product/pages/detailPackage/desktop/DetailSnb.tsx
































var DetailSNBComponent = function(props) {
    var ref, ref1, ref2;
    var event = props.eventDetail;
    var goodsCd = event.goodsCd, evCd = event.evCd;
    var ref3 = (0,useSigninUser/* default */.ZP)(), loginInfo = ref3.data;
    var eventPriceFetch = (0,useEventPrice/* default */.ZP)(evCd);
    var price = (0,eventUtil/* getPrice */.aS)((ref = eventPriceFetch.data) === null || ref === void 0 ? void 0 : ref.body);
    var eventMileageFetch = (0,useEventMileage/* default */.ZP)(evCd);
    var mileage = (ref1 = eventMileageFetch.data) === null || ref1 === void 0 ? void 0 : ref1.body;
    var bannerContentsFetch = (0,useBannerContents/* default */.ZP)("GORV"); // WEB_CONT_DIVI_CD 상품상세_요금영역
    var bannerContents = (ref2 = bannerContentsFetch.data) === null || ref2 === void 0 ? void 0 : ref2.body;
    var router = (0,next_router.useRouter)();
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref4[0];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)("slideIn"), 1), slide = ref5[0];
    var maxCount = 30;
    var ref6 = (0,react.useState)({
        A: 1,
        C: 0,
        I: 0
    }), count = ref6[0], setCount = ref6[1];
    var ref7 = (0,react.useState)([]), coupon = ref7[0], setCoupon = ref7[1];
    // 쿠폰 할인금액
    var discount = (0,react.useMemo)(function() {
        return coupon.reduce(function(acc, cur) {
            return acc + cur.calcObj.totalPrice;
        }, 0);
    }, [
        coupon
    ]);
    // 총액
    var totalPrice = (0,react.useMemo)(function() {
        if (!price) return 0;
        return price.adult * count.A + price.child * count.C + price.infant * count.I - discount;
    }, [
        count,
        price,
        discount
    ]);
    // + - 버튼
    var calculation = (0,react.useCallback)(function(type) {
        return function(number) {
            if (number > maxCount) return;
            if (discount > 0) {
                open(function(prop) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_Desktop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                        text: "쿠폰을 재적용 해주세요."
                    }));
                });
                setCoupon([]);
                return;
            }
            setCount(function(cur) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cur), (0,_define_property/* default */.Z)({}, type, number));
            });
        };
    }, [
        discount
    ]);
    /** 쿠폰 open */ var openPopCoupon = function() {
        var callbackCoupon = function(prop) {
            setCoupon(prop);
        };
        if ((loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.code) !== "0000") {
            open(function(prop) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_Desktop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                    alertType: "confirm",
                    text: "로그인 후 이용하실 수 있습니다. <br/>로그인하시겠습니까?",
                    afterConfirm: function() {
                        return LoginUtil.login();
                    }
                }));
            });
        } else {
            open(function(prop) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponPopup/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                    evCd: evCd,
                    count: count,
                    callback: callbackCoupon
                }));
            });
        }
    };
    /** 포인트 적립 안내 open */ var openPopPointSave = function() {
        open(function(prop) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PointSavePop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                evCd: evCd
            }));
        });
    };
    /** 출발일보기 slide */ var openPopEventList = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var result, body, availEvent, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,useGoodsOneAvailEvent/* goodsAvailEventAsync */.iS)(goodsCd)
                        ];
                    case 1:
                        result = _state.sent();
                        body = result.data.body;
                        _tmp = {};
                        _tmp1 = {};
                        availEvent = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp, body), (_tmp1.evStartDt = event.evStartDt, _tmp1));
                        slide(function(prop) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListPopup/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                                goodsCd: goodsCd,
                                availEvent: availEvent
                            }));
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function openPopEventList() {
            return _ref.apply(this, arguments);
        };
    }();
    /** 예약하기 버튼 텍스트 */ var reserveText = (0,eventUtil/* reserveButtonText */._f)(event);
    /** 예약하기 버튼 */ var handleReserve = function() {
        var ref, ref1;
        var msg = "";
        if (reserveText[1] === "예약마감") {
            msg = "예약이 마감되었습니다.<br/>출발일 변경에서 예약가능 상품으로 예약하시거나,<br/>담당자에게 문의 해주세요.";
        } else if (reserveText[1] === "출발완료") {
            msg = "이미 출발한 상품입니다.<br/>출발일 변경에서 예약가능 상품으로 예약하시거나,<br/>담당자에게 문의 해주세요.";
        }
        if (msg) {
            MessageUtil.alert(msg);
            return;
        }
        var adtCnt = count.A > 1 ? "".concat(count.A) : "1";
        var chdCnt = count.C > 0 ? "".concat(count.C) : "0";
        var infCnt = count.I > 0 ? "".concat(count.I) : "0";
        var ref2;
        var menu = (ref2 = (ref = (0,commonUtil/* getQueryParams */.vl)(location.search)) === null || ref === void 0 ? void 0 : ref.menu) !== null && ref2 !== void 0 ? ref2 : "";
        var dspSid = (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.dspSid;
        var path = "/product/reserve?evCd=".concat(evCd, "&adtCnt=").concat(adtCnt, "&chdCnt=").concat(chdCnt, "&infCnt=").concat(infCnt, "&menu=").concat(menu, "&dspSid=").concat(dspSid);
        /* 로그인 안되어있으면 로그인페이지 이동 */ if ((loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.code) !== "0000") {
            LoginUtil.loginRsvn(path);
            return;
        }
        router.push({
            pathname: path,
            query: {
                coupon: JSON.stringify(coupon),
                evCd: evCd,
                adtCnt: adtCnt,
                chdCnt: chdCnt,
                infCnt: infCnt,
                menu: menu
            }
        }, path);
    };
    // tagging 기획전 배너
    var ref8 = (0,useTagging/* useTaggingClick */.b)("pkg_select_promo_dtl"), taggingClickBanner = ref8.taggingClick;
    // tagging 출발일 보기
    var ref9 = (0,useTagging/* useTaggingClick */.b)("pkg_select_dtl_change", event), taggingClickChange = ref9.taggingClick;
    // tagging 예약하기
    var ref10 = (0,useTagging/* useTaggingClick */.b)("pkg_select_evCd_pkgDtl", {
        eventDetail: event,
        count: {
            adultCnt: count.A,
            childCnt: count.C,
            infantCnt: count.I
        },
        coupon: coupon
    }), taggingClickReserve = ref10.taggingClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* Box */.xu, {
        isFixed: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* ScrollWrap */.Il, {
                isOption: event.accomNm && event.webDisplayCls === "B",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* DepartureWrap */.b0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* InfoList */.Q4, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "출발"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                children: (0,eventUtil/* departureStart */.jn)(event)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "도착"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                children: (0,eventUtil/* returnArrival */.jp)(event)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "교통"
                                            }),
                                            event.trTp ? /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* Flex */.kC, {
                                                gap: "10",
                                                align: "center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AirlineIcon/* default */.Z, {
                                                    img: (0,eventUtil/* getTrafficIconUrl */.wz)(event),
                                                    title: event.trCompanyNm
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                children: "교통불포함"
                                            })
                                        ]
                                    }),
                                    event.accomNm && event.webDisplayCls === "B" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "옵션"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                children: event.accomNm
                                            })
                                        ]
                                    }),
                                    !(0,eventUtil/* isGoodsTpFH */.mk)(event.goodsTp) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "남은좌석"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                children: event.evStaCd === "05" ? "마감" : "".concat(event.avlilBlockQty, "석")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snb/* DepartureButton */.eq, {
                                size: "default",
                                width: "full",
                                text: "출발일 변경",
                                onClick: function() {
                                    openPopEventList();
                                    taggingClickChange();
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* PriceWrap */.PS, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* Assort */.Fs, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snb/* Age */.ZA, {
                                                children: "성인"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* PriceText */.Xd, {
                                                children: [
                                                    ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(price === null || price === void 0 ? void 0 : price.adult),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "원"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CountingButton/* default */.Z, {
                                        value: count.A,
                                        minValue: 1,
                                        increase: calculation("A"),
                                        decrease: calculation("A")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* Assort */.Fs, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snb/* Age */.ZA, {
                                                children: "아동"
                                            }),
                                            (0,eventUtil/* isGoodsTpFH */.mk)(event.goodsTp) && (price === null || price === void 0 ? void 0 : price.child) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: "별도문의"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* PriceText */.Xd, {
                                                children: [
                                                    ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(price === null || price === void 0 ? void 0 : price.child),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "원"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CountingButton/* default */.Z, {
                                        value: count.C,
                                        increase: calculation("C"),
                                        decrease: calculation("C")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* Assort */.Fs, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snb/* Age */.ZA, {
                                                children: "유아"
                                            }),
                                            (0,eventUtil/* isGoodsTpFH */.mk)(event.goodsTp) && (price === null || price === void 0 ? void 0 : price.infant) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: "별도문의"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* PriceText */.Xd, {
                                                children: [
                                                    ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(price === null || price === void 0 ? void 0 : price.infant),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "원"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CountingButton/* default */.Z, {
                                        value: count.I,
                                        increase: calculation("I"),
                                        decrease: calculation("I")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* CouponWrap */.xZ, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                        justify: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snb/* Coupon */.wV, {
                                children: "할인쿠폰"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                onClick: openPopCoupon,
                                children: "쿠폰 적용"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                        justify: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "쿠폰할인"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* Discount */.sz, {
                                children: [
                                    "-",
                                    ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(discount),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "원"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* TotalWrap */.lU, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* TotalPrice */.Mh, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                children: [
                                    ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(totalPrice),
                                    " "
                                ]
                            }),
                            "원"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* PriceInfo */.a8, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "(성인1인기준) ",
                                    mileage && ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber((0,goodsUtil/* getExpectMileage */.bd)(mileage)),
                                    "P 적립예정"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                onClick: openPopPointSave,
                                children: "포인트 적립 안내"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snb/* Reservation */.fe, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* TextButton */.Av, {
                            types: reserveText[0],
                            text: reserveText[1],
                            onClick: function() {
                                taggingClickReserve();
                                handleReserve();
                            },
                            width: "full"
                        })
                    }),
                    bannerContents && bannerContents.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(snb/* Banner */.jL, {
                            href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL).concat(item.link),
                            target: (0,commonUtil/* getTarget */.U9)(item.target),
                            onClick: function() {
                                return taggingClickBanner((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                    selectDiv: "reserveBanner"
                                }));
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: item.imgPath ? "".concat(config_public/* default.ENV_CIMG_CDN_URL */.Z.ENV_CIMG_CDN_URL).concat(item.imgPath) : (ico_nodata_default()),
                                alt: item.alt
                            })
                        }, index);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(snb/* ManagerBox */.Ik, {
                children: event.mgmUserInfo === "Y" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                            children: event.mgmDeptNm
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                            children: event.phoneDirect
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                            children: [
                                "담당자 ",
                                event.mgmUserNm
                            ]
                        }),
                        event.mgmUserTelNo && /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                            children: event.mgmUserTelNo
                        })
                    ]
                })
            })
        ]
    });
};
var DetailSNB = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailSnb Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailSNBComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var DetailSnb = (/*#__PURE__*/(0,react.memo)(DetailSNB));

// EXTERNAL MODULE: ./framework/utils/useConfigureAxios.ts + 43 modules
var useConfigureAxios = __webpack_require__(21741);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
;// CONCATENATED MODULE: ./pages/product/detailPackage.page.tsx




function detailPackage_page_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	@media print {\n		display: none;\n\n		#printPopup {\n			display: block;\n		}\n	}\n"
    ]);
    detailPackage_page_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













// import DetailReview from "@COMPONENTS/product/pages/detailPackage/desktop/DetailReview";










var detailPackage_page_Wrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e966fb53-0"
})(detailPackage_page_templateObject());
/* 최근 본 상품 저장 **/ var daykor = [
    "일",
    "월",
    "화",
    "수",
    "목",
    "금",
    "토"
];
var Page = function(props) {
    var ref, ref1;
    /** 예외처리 */ (0,react.useEffect)(function() {
        if (props.message) {
            alert(props.message);
            location.href = "".concat(config_public/* default.ENV_PORTAL_URL */.Z.ENV_PORTAL_URL);
        }
    }, []);
    if (props.message) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    /** 정상 */ var query = props.query, eventDetail = props.eventDetail, goodsImage = props.goodsImage;
    /** 로그인 정보 */ var signin = (0,useSigninUser/* default */.ZP)();
    var webCustNo = ((ref = signin.data) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.webCustNo) || "";
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    /** 최근 본 상품 SET */ var setRecently = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(eventDetail, goodsImage) {
            var webCustId, ref, userId, evCd, evStartDt, outDeprtTm, evArriveDt, inArrvTm, trCompanySnm, trCompanyNm, trTp, pathname, queries, search, detailedUrl, imgUrl, _evCd, goodsId, _evNm, goodsName, type, viewDate, category, soldoutYn, trafficCode, _tmp, dayOfWeekStart, dayOfWeekArrive, outDeprtTime, inArrvTime, information, result, _tmp1, _tmp2, e;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        webCustId = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "";
                        userId = (0,commonUtil/* getCookie */.ej)("userId");
                        if (!userId) return [
                            2
                        ];
                        evCd = eventDetail.evCd, evStartDt = eventDetail.evStartDt, outDeprtTm = eventDetail.outDeprtTm, evArriveDt = eventDetail.evArriveDt, inArrvTm = eventDetail.inArrvTm, trCompanySnm = eventDetail.trCompanySnm, trCompanyNm = eventDetail.trCompanyNm, trTp = eventDetail.trTp;
                        pathname = location.pathname;
                        queries = (0,commonUtil/* getQueryParams */.vl)();
                        search = "?menu=".concat(queries.menu, "&dspSid=").concat(queries.dspSid, "&evCd=").concat(evCd);
                        detailedUrl = "".concat(config_public/* default.ENV_PRODUCT_URL */.Z.ENV_PRODUCT_URL).concat(pathname).concat(search);
                        imgUrl = ((ref = goodsImage[0]) === null || ref === void 0 ? void 0 : ref.imageThum3) || "";
                        goodsId = (_evCd = eventDetail.evCd) !== null && _evCd !== void 0 ? _evCd : "";
                        goodsName = (_evNm = eventDetail.evNm) !== null && _evNm !== void 0 ? _evNm : "";
                        type = eventDetail.goodsTp === "D" ? "DMT" : "PKG";
                        viewDate = dayjs_min_default()().format("YYYY.MM.DD HH:mm:ss");
                        category = (0,goodsUtil/* goodsTpLabel */.mk)(eventDetail.goodsTp).join(";");
                        soldoutYn = "";
                        _tmp = {};
                        trafficCode = (_tmp.A = trCompanySnm, _tmp.T = "TRAIN", _tmp.S = "SHIP", _tmp.B = "BUS", _tmp)[trTp] || "ETC";
                        dayOfWeekStart = daykor[dayjs_min_default()(evStartDt).day()];
                        dayOfWeekArrive = daykor[dayjs_min_default()(evArriveDt).day()];
                        outDeprtTime = outDeprtTm ? "".concat(outDeprtTm.slice(0, 2), ":").concat(outDeprtTm.slice(2)) : "";
                        inArrvTime = inArrvTm ? "".concat(inArrvTm.slice(0, 2), ":").concat(inArrvTm.slice(2)) : "";
                        information = "".concat(dayjs_min_default()(evStartDt).format("YYYY.MM.DD"), ";(").concat(dayOfWeekStart, ");").concat(outDeprtTime, ";") + "".concat(dayjs_min_default()(evArriveDt).format("YYYY.MM.DD"), ";(").concat(dayOfWeekArrive, ");").concat(inArrvTime, ";") + "".concat(trafficCode, ";").concat(trTp ? trCompanyNm : "교통불포함");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        _tmp1 = {};
                        return [
                            4,
                            (0,useConfigureAxios/* default */.Z)((_tmp1.url = "".concat(config_public/* default.ENV_ESSENTIAL_API_BASEPATH */.Z.ENV_ESSENTIAL_API_BASEPATH, "/api/user/recentlyViewed"), _tmp1.method = "POST", _tmp1.data = {
                                imgUrl: imgUrl,
                                goodsId: goodsId,
                                goodsName: goodsName,
                                information: information,
                                type: type,
                                viewDate: viewDate,
                                userId: userId,
                                detailedUrl: detailedUrl,
                                webCustId: webCustId,
                                category: category,
                                soldoutYn: soldoutYn
                            }, _tmp1))
                        ];
                    case 2:
                        result = _state.sent();
                        _tmp2 = {};
                        if (result.data.code === "0000") queryClient.refetchQueries((_tmp2.queryKey = [
                            "useGetRecently"
                        ], _tmp2.type = "active", _tmp2));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function setRecently(eventDetail, goodsImage) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (!signin.isFetching) {
            setRecently(eventDetail, goodsImage, webCustNo);
        }
    }, [
        signin
    ]);
    // tagging
    (0,useTagging/* useTaggingLoad */.q)("pkg_view_dtl", eventDetail);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailPackage_page_Wrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header_Desktop/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Container */.W2, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailHeader/* default */.Z, (0,_object_spread/* default */.Z)({}, props)),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* DescriptionWrap */._O, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailSnb, {
                                        eventDetail: eventDetail
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* DescriptionContent */.jb, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailContents/* default */.ZP, (0,_object_spread/* default */.Z)({}, props)),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailSchedule/* default */.Z, (0,_object_spread/* default */.Z)({}, query)),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_DetailPromotion, (0,_object_spread/* default */.Z)({}, query))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_DetailRecommend, (0,_object_spread/* default */.Z)({}, query))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GTMTags/* default */.Z, (0,_object_spread/* default */.Z)({}, props))
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var detailPackage_page = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7700,6119,1500,481,8861,8127,8866,2722,9888,2392,7372,1171,7834,1156,2349,1877,3460,2045,9071,8954,9774,2888,179], function() { return __webpack_exec__(21728); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);